/**
 * Paths every HEXAUNITY application shares. Each application's own
 * `router/paths.ts` spreads these and adds its screens, so the shell, the
 * guards and the auth pages agree on where login and the landing page are.
 */
export const PATHS = {
  root: '/',
  auth: {
    login: '/login',
    forgotPassword: '/forgot-password',
    changePassword: '/change-password',
  },
  app: {
    dashboard: '/dashboard',
    unauthorized: '/unauthorized',
  },
  notFound: '*',
} as const;
